/** @enum {string} — server-side status values for a document intake job */
export const DocumentIntakeJobStatus = {
  PENDING: 'Pending',
  IN_PROGRESS: 'InProgress',
  COMPLETED: 'Completed',
  FAILED: 'Failed',
  CANCELLED: 'Cancelled',
};

/** Terminal statuses — no further polling or push updates expected */
export const DocumentIntakeTerminalStatuses = new Set([
  DocumentIntakeJobStatus.COMPLETED,
  DocumentIntakeJobStatus.FAILED,
  DocumentIntakeJobStatus.CANCELLED,
]);

/** Redux action type constants for the documentIntake slice */
export const DOCUMENT_INTAKE_ACTION_TYPE = {
  CREATE_JOB: 'documentIntake/CREATE_JOB',
  CREATE_JOB_SUCCESS: 'documentIntake/CREATE_JOB_SUCCESS',
  CREATE_JOB_FAILURE: 'documentIntake/CREATE_JOB_FAILURE',

  LOAD_JOB: 'documentIntake/LOAD_JOB',
  LOAD_JOB_SUCCESS: 'documentIntake/LOAD_JOB_SUCCESS',
  LOAD_JOB_FAILURE: 'documentIntake/LOAD_JOB_FAILURE',

  LOAD_JOBS_FOR_LOAN: 'documentIntake/LOAD_JOBS_FOR_LOAN',
  LOAD_JOBS_FOR_LOAN_SUCCESS: 'documentIntake/LOAD_JOBS_FOR_LOAN_SUCCESS',
  LOAD_JOBS_FOR_LOAN_FAILURE: 'documentIntake/LOAD_JOBS_FOR_LOAN_FAILURE',

  CANCEL_JOB: 'documentIntake/CANCEL_JOB',
  CANCEL_JOB_SUCCESS: 'documentIntake/CANCEL_JOB_SUCCESS',
  CANCEL_JOB_FAILURE: 'documentIntake/CANCEL_JOB_FAILURE',

  JOB_UPSERT: 'documentIntake/JOB_UPSERT',

  SET_ACTIVE_JOB_FOR_LOAN: 'documentIntake/SET_ACTIVE_JOB_FOR_LOAN',
  CLEAR_ACTIVE_JOB_FOR_LOAN: 'documentIntake/CLEAR_ACTIVE_JOB_FOR_LOAN',
};

/** SignalR event names emitted by the AI process hub for intake jobs */
export const DocumentIntakeSignalREventType = {
  JOB_STARTED: 'intake_job_started',
  JOB_PROGRESS: 'intake_job_progress',
  JOB_COMPLETED: 'intake_job_completed',
  JOB_FAILED: 'intake_job_failed',
};

/** Polling interval (ms) used as a fallback when SignalR is unavailable */
export const DOCUMENT_INTAKE_POLL_INTERVAL_MS = 4000;

/**
 * The backend segment status value set after a segment has been successfully filed
 * (i.e. the corresponding document has been created in the loan's document list).
 * Used by hasUnfiledSegments to detect Completed jobs that still have pending work.
 */
export const DOCUMENT_INTAKE_SEGMENT_STATUS_FILED = 'Filed';

/** Human-readable display labels for each job status */
export const DOCUMENT_INTAKE_STATUS_LABEL = {
  [DocumentIntakeJobStatus.PENDING]: 'Queued',
  [DocumentIntakeJobStatus.IN_PROGRESS]: 'Processing',
  [DocumentIntakeJobStatus.COMPLETED]: 'Ready to review',
  [DocumentIntakeJobStatus.FAILED]: 'Failed',
  [DocumentIntakeJobStatus.CANCELLED]: 'Cancelled',
};
